export function Features() {
  const features = [
    {
      title: 'Privacy',
      description: 'Your data stays secure with enterprise-grade security and no data sharing.',
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1ZM10 17L6 13L7.41 11.59L10 14.17L16.59 7.58L18 9L10 17Z"
            fill="rgba(255, 255, 255, 0.9)"
          />
        </svg>
      ),
    },
    {
      title: 'Boost Engagement',
      description:
        'Transform passive visitors into active users with interactive AI conversations that keep them on your site longer.',
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16 6L18.29 8.29L13.41 13.17L9.41 9.17L2 16.59L3.41 18L9.41 12L13.41 16L19.71 9.71L22 12V6H16Z"
            fill="rgba(255, 255, 255, 0.9)"
          />
        </svg>
      ),
    },
    {
      title: 'Easy to Install',
      description: 'Integrate the Ask Anything button on your site with just a few lines of code.',
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8 3C6.9 3 6 3.9 6 5V21L12 18L18 21V5C18 3.9 17.1 3 16 3H8ZM8 5H16V18.09L12 15.82L8 18.09V5ZM13 7H11V9H9V11H11V13H13V11H15V9H13V7Z"
            fill="rgba(255, 255, 255, 0.9)"
          />
        </svg>
      ),
    },
  ]

  return (
    <section className="features-section">
      <div className="features-container">
        <h2 className="features-title">Why choose us?</h2>
        <div className="features-content">
          <div className="features-list">
            {features.map((feature, index) => (
              <div key={index} className={`feature-item feature-item-${index + 1}`}>
                <div className="feature-icon">{feature.icon}</div>
                <div className="feature-text">
                  <h3 className="feature-title">{feature.title}</h3>
                  <p className="feature-description">{feature.description}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="features-image">
            <div className="ai-search-illustration">
              <div className="search-interface">
                <div className="search-bar">
                  <div className="search-icon"></div>
                  <div className="search-text">Ask anything...</div>
                </div>
                <div className="search-results">
                  <div className="result-item"></div>
                  <div className="result-item"></div>
                  <div className="result-item"></div>
                </div>
                <div className="ai-response">
                  <div className="ai-avatar"></div>
                  <div className="response-bubble"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
